import React from "react";

export const PrivateContext = React.createContext({});

export const PrivateProvider = PrivateContext.Provider;
export const PrivateConsumer = PrivateContext.Consumer;
